import _classCallCheck from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { UpploadEffect } from "../../effect";
import Cropper from "cropperjs";
import { safeListen, fitImageToContainer, canvasToBlob } from "../../helpers/elements";

var Crop =
/*#__PURE__*/
function (_UpploadEffect) {
  _inherits(Crop, _UpploadEffect);

  function Crop() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        aspectRatio = _ref.aspectRatio,
        aspectRatioOptions = _ref.aspectRatioOptions,
        hideAspectRatioSettings = _ref.hideAspectRatioSettings,
        autoCropArea = _ref.autoCropArea,
        viewMode = _ref.viewMode;

    _classCallCheck(this, Crop);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Crop).call(this));
    _this.name = "crop";
    _this.icon = "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M74 0v182h134v-25h-26V74H99V48h96c4 0 7 1 9 4 3 2 4 5 4 9v121h48v26h-48v48h-26v-48H61a13 13 0 01-13-13V74H0V48h48V0h26z\" fill=\"#000\" fill-rule=\"nonzero\"/></svg>";
    _this.aspectRatio = NaN;
    _this.hideAspectRatioSettings = false;
    _this.aspectRatioOptions = {
      free: NaN,
      square: 1,
      "16:9": 16 / 9
    };
    _this.autoCropArea = 1;
    _this.viewMode = 1;

    _this.template = function (_ref2) {
      var file = _ref2.file,
          translate = _ref2.translate;
      var image = URL.createObjectURL(file);
      return "\n      <div class=\"uppload-cropping-element\">\n        <img style=\"width: 20px\" alt=\"\" src=\"".concat(image, "\">\n      </div>\n      ").concat(!_this.aspectRatio && !_this.hideAspectRatioSettings ? "<div class=\"uppload-actions\">\n        ".concat(Object.keys(_this.aspectRatioOptions).map(function (aspectRatio, index) {
        return "\n          <input value=\"".concat(_this.aspectRatioOptions[aspectRatio], "\" data-name=\"").concat(aspectRatio, "\" name=\"crop-aspect-ratio\" type=\"radio\"").concat(!index ? " checked" : "", " id=\"crop-aspect-ratio-").concat(aspectRatio, "\">\n          <label for=\"crop-aspect-ratio-").concat(aspectRatio, "\">").concat(translate("effects.crop.aspectRatios.".concat(aspectRatio)) || aspectRatio, "</label>");
      }).join(""), "\n      </div>") : "", "\n    ");
    };

    _this.handlers = function (params) {
      var cropperElement = params.uppload.container.querySelector(".uppload-cropping-element img");

      if (cropperElement) {
        fitImageToContainer(params, cropperElement).then(function () {
          var cropper = new Cropper(cropperElement, {
            aspectRatio: _this.aspectRatio,
            autoCropArea: _this.autoCropArea,
            viewMode: _this.viewMode,
            ready: function ready() {
              canvasToBlob(cropper.getCroppedCanvas()).then(function (blob) {
                return params.next(blob);
              });
            },
            cropend: function cropend() {
              canvasToBlob(cropper.getCroppedCanvas()).then(function (blob) {
                return params.next(blob);
              });
            }
          });
          var aspectRatios = params.uppload.container.querySelectorAll("input[name='crop-aspect-ratio']");
          aspectRatios.forEach(function (aspectRatio) {
            safeListen(aspectRatio, "change", function () {
              var selectedAspectRatio = params.uppload.container.querySelector("input[name='crop-aspect-ratio']:checked");

              if (selectedAspectRatio) {
                cropper.setAspectRatio(_this.aspectRatioOptions[selectedAspectRatio.getAttribute("data-name") || "free"]);
                canvasToBlob(cropper.getCroppedCanvas()).then(function (blob) {
                  return params.next(blob);
                });
              }
            });
          });
        });
      }
    };

    if (aspectRatio) _this.aspectRatio = aspectRatio;
    if (aspectRatioOptions) _this.aspectRatioOptions = aspectRatioOptions;
    if (autoCropArea) _this.autoCropArea = autoCropArea;
    if (viewMode) _this.viewMode = viewMode;
    if (hideAspectRatioSettings) _this.hideAspectRatioSettings = hideAspectRatioSettings;
    return _this;
  }

  return Crop;
}(UpploadEffect);

export { Crop as default };